/** Formatea a USD sin centavos. */
export function formatUSD(n: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n);
}

/** Rango "$X – $Y" para mostrar y para el payload (estimator_range). */
export function formatRange(min: number, max: number): string {
  return `${formatUSD(min)} – ${formatUSD(max)}`;
}
